(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chatbotsidrek"] && !Shopify.designMode) return;
  try {
    
(function () {
  function track(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  document.querySelectorAll('.lq-chatbot').forEach(function (root) {
    if (root.dataset.lqInit) return;
    root.dataset.lqInit = '1';

    var config = JSON.parse(root.querySelector('[data-lq-config]').textContent);
    var panel = root.querySelector('[data-lq-panel]');
    var messages = root.querySelector('[data-lq-messages]');
    var cardsWrap = root.querySelector('[data-lq-cards]');
    var form = root.querySelector('[data-lq-form]');
    var input = root.querySelector('[data-lq-input]');
    var launcher = root.querySelector('.lq-launcher');
    var statusEl = root.querySelector('[data-lq-status]');
    var dotEl = root.querySelector('[data-lq-dot]');
    var teaser = root.querySelector('[data-lq-teaser]');
    var storeKey = 'lq-chat-' + config.sectionId;

    var state;
    try {
      state = JSON.parse(sessionStorage.getItem(storeKey)) || null;
    } catch (e) { state = null; }
    if (!state) state = { msgs: [], started: false, open: false, teaserOff: false, fails: 0, mode: 'normal' };

    function save() {
      if (state.msgs.length > 30) state.msgs = state.msgs.slice(-30);
      try { sessionStorage.setItem(storeKey, JSON.stringify(state)); } catch (e) {}
    }

    function isOpenNow() {
      if (!config.hours.enabled) return true;
      var days = String(config.hours.days || '').split(',').map(function (d) { return parseInt(d, 10); });
      var now = new Date();
      var store = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + config.hours.tz * 3600000);
      return days.indexOf(store.getDay()) !== -1 && store.getHours() >= config.hours.open && store.getHours() < config.hours.close;
    }

    function refreshStatus() {
      if (!config.hours.enabled) return;
      if (!isOpenNow()) {
        if (statusEl && config.hours.offlineText) statusEl.textContent = config.hours.offlineText;
        if (dotEl) dotEl.classList.add('is-offline');
      } else {
        if (dotEl) dotEl.classList.remove('is-offline');
      }
    }

    function scrollDown() {
      messages.scrollTop = messages.scrollHeight;
    }

    function waUrl(text) {
      return 'https://wa.me/' + String(config.whatsapp).replace(/\D/g, '') + '?text=' + encodeURIComponent(text);
    }

    function fmtMoney(cents) {
      try {
        return new Intl.NumberFormat(config.locale || 'es', { style: 'currency', currency: config.currency }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function ratingHtml(card) {
      var rv = card.rating;
      if (rv && typeof rv === 'object') rv = rv.value;
      if (!rv) return '';
      var count = card.ratingCount ? ' (' + esc(card.ratingCount) + ')' : '';
      return '<p class="lq-prod__rating">⭐ ' + esc(rv) + count + '</p>';
    }

    function prodHtml(card) {
      return '<div class="lq-prod">' +
        (card.image ? '<img class="lq-prod__img" src="' + esc(card.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<div><p class="lq-prod__title">' + esc(card.title) + '</p>' +
        ratingHtml(card) +
        (card.price ? '<p class="lq-prod__price">' + esc(card.price) + '</p>' : '') +
        '</div></div>';
    }

    function productBtns(card) {
      var btns = [{ u: card.url, l: card.buttonLabel }];
      if (card.available && card.variantId) btns.push({ v: String(card.variantId), l: config.cart.addLabel });
      return btns;
    }

    function showProductCard(card) {
      var html = prodHtml(card) + (card.description ? '<p>' + esc(card.description) + '</p>' : '');
      botReply(html, productBtns(card), { feedback: true });
    }

    function showCart(fromChip) {
      if (fromChip) addMessage('user', config.cart.label);
      var t = showTyping();
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          t.remove();
          track('chat_cart_view', {});
          if (!cart.item_count) {
            addMessage('bot', '<p>' + esc(config.cart.empty) + '</p>');
            return;
          }
          var html = '<p>' + esc(config.cart.intro) + '</p>';
          cart.items.slice(0, 4).forEach(function (it) {
            html += '<p>' + it.quantity + '× ' + esc(it.product_title) + ' — ' + esc(fmtMoney(it.final_line_price)) + '</p>';
          });
          if (cart.items.length > 4) html += '<p>…</p>';
          html += '<p><strong>Total: ' + esc(fmtMoney(cart.total_price)) + '</strong></p>';
          addMessage('bot', html, [{ u: '/checkout', l: config.cart.checkoutLabel }, { u: config.cart.url, l: config.cart.label }]);
          state.fails = 0;
          save();
        })
        .catch(function () { t.remove(); fallback(config.cart.label); });
    }

    function addToCart(variantId, btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return r.json();
        })
        .then(function () {
          btn.textContent = '✓';
          track('chat_add_to_cart', {});
          botReply('<p>' + esc(config.cart.addedMessage) + '</p>', [{ u: '/checkout', l: config.cart.checkoutLabel }]);
        })
        .catch(function () {
          btn.disabled = false;
          botReply('<p>' + esc(config.cart.addError) + '</p>');
        });
    }

    function searchProducts(text, next) {
      var t = showTyping();
      var url = '/search/suggest.json?q=' + encodeURIComponent(text) + '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=hide';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          t.remove();
          var prods = (((data || {}).resources || {}).results || {}).products || [];
          if (!prods.length) { next(); return; }
          track('chat_search', { chat_query: text });
          var html = '<p>' + esc(config.search.intro) + '</p>';
          prods.forEach(function (p) {
            var cents = Math.round(parseFloat(p.price) * 100);
            html += '<a class="lq-prod lq-prod--link" href="' + esc(p.url) + '">' +
              (p.image ? '<img class="lq-prod__img" src="' + esc(p.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
              '<div><p class="lq-prod__title">' + esc(p.title) + '</p>' +
              (isNaN(cents) ? '' : '<p class="lq-prod__price">' + esc(fmtMoney(cents)) + '</p>') +
              '</div></a>';
          });
          addMessage('bot', html);
          state.fails = 0;
          save();
        })
        .catch(function () { t.remove(); next(); });
    }

    function renderMessage(msg, animate) {
      var el = document.createElement('div');
      el.className = 'lq-msg lq-msg--' + (msg.r === 'u' ? 'user' : 'bot');
      if (!animate) el.style.animation = 'none';
      if (msg.r === 'u') {
        el.textContent = msg.h;
      } else {
        el.innerHTML = msg.h;
        if (msg.btns && msg.btns.length) {
          var row = document.createElement('div');
          row.className = 'lq-msg__btns';
          msg.btns.forEach(function (b) {
            if (!b.l) return;
            if (b.v) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'lq-msg__btn';
              btn.dataset.lqAdd = b.v;
              btn.textContent = b.l;
              row.appendChild(btn);
              return;
            }
            if (!b.u) return;
            var a = document.createElement('a');
            a.className = 'lq-msg__btn';
            a.href = b.u;
            if (b.u.indexOf('http') === 0) { a.target = '_blank'; a.rel = 'noopener'; }
            a.textContent = b.l;
            row.appendChild(a);
          });
          el.appendChild(row);
        }
      }
      messages.appendChild(el);
      return el;
    }

    function addFeedback() {
      if (!config.feedback.enabled) return;
      var row = document.createElement('div');
      row.className = 'lq-feedback';
      row.innerHTML =
        '<span class="lq-feedback__label">' + esc(config.feedback.question) + '</span>' +
        '<button type="button" class="lq-feedback__btn" data-lq-vote="up" aria-label="Si">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88z"/></svg>' +
        '</button>' +
        '<button type="button" class="lq-feedback__btn" data-lq-vote="down" aria-label="No">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transform:rotate(180deg)"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88z"/></svg>' +
        '</button>';
      messages.appendChild(row);
      scrollDown();
    }

    function addMessage(role, html, btns, opts) {
      opts = opts || {};
      var msg = { r: role === 'user' ? 'u' : 'b', h: html, btns: btns || [] };
      renderMessage(msg, true);
      state.msgs.push(msg);
      save();
      if (role !== 'user' && opts.feedback) addFeedback();
      scrollDown();
    }

    function showTyping() {
      var t = document.createElement('div');
      t.className = 'lq-typing';
      t.innerHTML = '<span></span><span></span><span></span>';
      messages.appendChild(t);
      scrollDown();
      return t;
    }

    function botReply(html, btns, opts) {
      var t = showTyping();
      setTimeout(function () {
        t.remove();
        addMessage('bot', html, btns, opts);
      }, (opts && opts.delay) || 700);
    }

    function normalize(s) {
      return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s#]/g, ' ');
    }

    function words(s) {
      return normalize(s).split(/\s+/).filter(function (w) { return w.length > 2; }).map(function (w) {
        return w.replace(/(es|s)$/, '');
      });
    }

    function scoreCard(card, qWords, qNorm) {
      var score = 0;
      var kw = normalize(card.keywords || '');
      var title = normalize((card.title || '') + ' ' + (card.label || ''));
      kw.split(',').forEach(function (phrase) {
        phrase = phrase.trim();
        if (phrase.length > 3 && qNorm.indexOf(phrase) !== -1) score += 3;
      });
      qWords.forEach(function (w) {
        if (kw.indexOf(w) !== -1) score += 2;
        else if (title.indexOf(w) !== -1) score += 1;
      });
      return score;
    }

    function rankCards(text) {
      var qNorm = normalize(text);
      var qWords = words(text);
      return config.cards.map(function (card, i) {
        return { card: card, i: i, score: card.title ? scoreCard(card, qWords, qNorm) : 0 };
      }).sort(function (a, b) { return b.score - a.score; });
    }

    function answerCard(card) {
      if (!card || !card.title) return;
      addMessage('user', card.label || card.title);
      track('chat_card_click', { chat_card: card.label || card.title });
      if (card.kind === 'product') {
        showProductCard(card);
      } else {
        botReply(card.answer, [{ u: card.buttonUrl, l: card.buttonLabel }], { feedback: true });
      }
      state.fails = 0;
      save();
    }

    function checkCoupon(qNorm) {
      if (!config.coupon.enabled || !config.coupon.code) return false;
      var hit = String(config.coupon.keywords || '').split(',').some(function (k) {
        k = normalize(k).trim();
        return k.length > 2 && qNorm.indexOf(k) !== -1;
      });
      if (!hit) return false;
      var html = '<p>' + esc(config.coupon.message) + '</p>' +
        '<span class="lq-coupon">' + esc(config.coupon.code) +
        '<button type="button" class="lq-coupon__copy" data-lq-copy="' + esc(config.coupon.code) + '">' + esc(config.coupon.copyLabel) + '</button></span>';
      botReply(html, null, { feedback: true });
      track('chat_coupon_shown', {});
      state.fails = 0;
      save();
      return true;
    }

    function escalate(question) {
      state.fails = 0;
      var btns = [];
      if (config.whatsapp) {
        btns.push({ u: waUrl('Hola! Tengo una consulta: ' + question), l: config.contactLabel });
      } else if (config.contactUrl) {
        btns.push({ u: config.contactUrl, l: config.contactLabel });
      }
      botReply(config.escalation, btns);
      track('chat_escalation', {});
      save();
    }

    function fallback(text) {
      state.fails = (state.fails || 0) + 1;
      track('chat_fallback', { chat_query: text });
      if (state.fails >= 2 && (config.whatsapp || config.contactUrl)) {
        escalate(text);
        return;
      }
      var ranked = rankCards(text).filter(function (r) {
        if (r.score > 0) return true;
        var qw = words(text);
        var hay = normalize((r.card.keywords || '') + ' ' + (r.card.title || ''));
        return qw.some(function (w) { return w.length > 3 && hay.indexOf(w.slice(0, 4)) !== -1; });
      }).slice(0, 2);
      var html = '<p>' + esc(config.fallback) + '</p>';
      if (ranked.length) {
        html += '<p class="lq-cards-label" style="padding:0">' + esc(config.suggestTitle) + '</p>';
        ranked.forEach(function (r) {
          html += '<button type="button" class="lq-sugg" data-lq-sugg="' + r.i + '">' + esc(r.card.label || r.card.title) + '</button>';
        });
      }
      var btns = [];
      if (config.whatsapp) btns.push({ u: waUrl('Hola! Tengo una consulta: ' + text), l: config.contactLabel });
      else if (config.contactUrl) btns.push({ u: config.contactUrl, l: config.contactLabel });
      botReply(html, btns);
      save();
    }

    function askAI(text) {
      var t = showTyping();
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      var history = state.msgs.slice(-10).map(function (m) {
        var d = document.createElement('div');
        d.innerHTML = m.h;
        return { role: m.r === 'u' ? 'user' : 'assistant', content: d.textContent.slice(0, 500) };
      });
      fetch(config.aiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: history, page: config.pageType }),
        signal: controller.signal
      })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          clearTimeout(timer);
          t.remove();
          addMessage('bot', esc(data.reply || data.message || config.aiError).replace(/\n/g, '<br>'), null, { feedback: true });
          track('chat_ai_reply', {});
          state.fails = 0;
          save();
        })
        .catch(function () {
          clearTimeout(timer);
          t.remove();
          fallback(text);
        });
    }

    function handleTracking(text) {
      state.mode = 'normal';
      var num = (text.match(/#?\d{2,}/) || [text])[0];
      var btns = [{ u: config.tracking.accountUrl, l: config.tracking.accountLabel }];
      if (config.whatsapp) {
        btns.push({ u: waUrl('Hola! Quiero saber el estado de mi pedido ' + num), l: config.contactLabel });
      }
      botReply(config.tracking.reply, btns, { feedback: true });
      track('chat_order_lookup', {});
      save();
    }

    function startTracking() {
      addMessage('user', config.tracking.label);
      state.mode = 'awaiting_order';
      botReply('<p>' + esc(config.tracking.prompt) + '</p>');
      save();
      input.focus();
    }

    function handleText(text) {
      addMessage('user', text);
      track('chat_message_sent', {});
      if (state.mode === 'awaiting_order') {
        handleTracking(text);
        return;
      }
      var qNorm = normalize(text);
      if (config.tracking.enabled && /pedido|orden|tracking|seguimiento|rastrear|donde esta/.test(qNorm) && /\d{2,}/.test(qNorm)) {
        handleTracking(text);
        return;
      }
      if (config.cart.enabled && /\b(carrito|carro|cesta|bolsa|checkout)\b|finalizar (la )?compra|terminar (la )?compra/.test(qNorm)) {
        showCart(false);
        return;
      }
      if (checkCoupon(qNorm)) return;
      var best = rankCards(text)[0];
      if (best && best.score >= 2) {
        var card = best.card;
        state.fails = 0;
        if (card.kind === 'product') {
          showProductCard(card);
        } else {
          botReply(card.answer, [{ u: card.buttonUrl, l: card.buttonLabel }], { feedback: true });
        }
        save();
      } else if (config.search.enabled) {
        searchProducts(text, function () {
          if (config.aiEndpoint) askAI(text);
          else fallback(text);
        });
      } else if (config.aiEndpoint) {
        askAI(text);
      } else {
        fallback(text);
      }
    }

    function restore() {
      state.msgs.forEach(function (m) { renderMessage(m, false); });
      scrollDown();
    }

    function start() {
      if (state.started) return;
      state.started = true;
      botReply(config.welcome, null, { delay: 500 });
      if (config.cardsTitle && cardsWrap.children.length) {
        var label = document.createElement('p');
        label.className = 'lq-cards-label';
        label.textContent = config.cardsTitle;
        cardsWrap.parentNode.insertBefore(label, cardsWrap);
      }
      save();
    }

    function hideTeaser(persist) {
      if (teaser) teaser.hidden = true;
      if (persist) { state.teaserOff = true; save(); }
    }

    function getFocusable() {
      return panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
    }

    function setOpen(open, animate) {
      state.open = open;
      root.classList.toggle('is-open', open);
      root.querySelectorAll('[data-lq-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) {
        hideTeaser(false);
        panel.hidden = false;
        if (animate === false) {
          panel.classList.add('is-visible');
        } else {
          requestAnimationFrame(function () { panel.classList.add('is-visible'); });
        }
        start();
        refreshStatus();
        setTimeout(function () { input.focus(); }, animate === false ? 0 : 250);
        var badge = root.querySelector('[data-lq-badge]');
        if (badge) badge.remove();
        track('chat_open', {});
      } else {
        panel.classList.remove('is-visible');
        setTimeout(function () { panel.hidden = true; }, 220);
        launcher.focus();
      }
      save();
    }

    root.querySelectorAll('[data-lq-toggle]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(!state.open); });
    });

    cardsWrap.addEventListener('click', function (e) {
      var special = e.target.closest('[data-lq-special]');
      if (special) {
        if (special.dataset.lqSpecial === 'tracking') startTracking();
        if (special.dataset.lqSpecial === 'cart') showCart(true);
        return;
      }
      var btn = e.target.closest('[data-lq-card]');
      if (btn) answerCard(config.cards[parseInt(btn.dataset.lqCard, 10)]);
    });

    messages.addEventListener('click', function (e) {
      var add = e.target.closest('[data-lq-add]');
      if (add) { addToCart(add.dataset.lqAdd, add); return; }
      var sugg = e.target.closest('[data-lq-sugg]');
      if (sugg) { answerCard(config.cards[parseInt(sugg.dataset.lqSugg, 10)]); return; }
      var copy = e.target.closest('[data-lq-copy]');
      if (copy) {
        var code = copy.dataset.lqCopy;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        copy.textContent = '✓';
        track('chat_coupon_copy', {});
        return;
      }
      var vote = e.target.closest('[data-lq-vote]');
      if (vote) {
        var row = vote.closest('.lq-feedback');
        track('chat_feedback', { chat_vote: vote.dataset.lqVote });
        row.innerHTML = '<span class="lq-feedback__label">' + esc(config.feedback.thanks) + '</span>';
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = input.value.trim();
      if (!text) return;
      input.value = '';
      handleText(text);
    });

    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = getFocusable();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) setOpen(false);
    });

    if (teaser && config.teaser.enabled && !state.teaserOff && !state.started) {
      var pageOk = config.teaser.pages === 'all' || config.teaser.pages === config.pageType;
      if (pageOk) {
        setTimeout(function () {
          if (!state.open && !state.started) {
            teaser.hidden = false;
            track('chat_teaser_shown', {});
          }
        }, (config.teaser.delay || 8) * 1000);
      }
      teaser.querySelector('[data-lq-teaser-open]').addEventListener('click', function () {
        hideTeaser(true);
        track('chat_teaser_click', {});
        setOpen(true);
      });
      teaser.querySelector('[data-lq-teaser-close]').addEventListener('click', function () {
        hideTeaser(true);
      });
    }

    refreshStatus();
    if (state.msgs.length) {
      restore();
      if (config.cardsTitle && cardsWrap.children.length) {
        var label = document.createElement('p');
        label.className = 'lq-cards-label';
        label.textContent = config.cardsTitle;
        cardsWrap.parentNode.insertBefore(label, cardsWrap);
      }
    }
    if (state.open) setOpen(true, false);
    if (state.started) {
      var badge = root.querySelector('[data-lq-badge]');
      if (badge) badge.remove();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
